import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchCodeOfvoilationModule } from "./learningAPI";

export interface CodeOfVoilationState {
  getcodeofvoilation: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: CodeOfVoilationState = {
  getcodeofvoilation: [],
  status: "idle",
};

export const GetCodeOfVoilationModule = createAsyncThunk(
  "codeofvoilation/fetchCodeOfvoilation",
  async () => {
    const response = await fetchCodeOfvoilationModule();
    return response;
  }
);

export const CodeOfVoilationModuleSlice = createSlice({
  name: "CodeOfVoilation",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCodeOfVoilationModule.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCodeOfVoilationModule.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetCodeOfVoilationModule.fulfilled, (state, action) => {
        state.status = "idle";
        state.getcodeofvoilation =action.payload;
      });
  },
});

export const {} = CodeOfVoilationModuleSlice.actions;

export const selectCodeOfVoilationModule = (state: RootState) => {
  return state.CodeOfVoilationModule.getcodeofvoilation;
};

export default CodeOfVoilationModuleSlice.reducer;
